var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackpackActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.5H20.5C22.0913 7.5 23.6174 8.13214 24.7426 9.25736C25.8679 10.3826 26.5 11.9087 26.5 13.5V27.5C26.5 27.7652 26.3946 28.0196 26.2071 28.2071C26.0196 28.3946 25.7652 28.5 25.5 28.5H6.5C6.23478 28.5 5.98043 28.3946 5.79289 28.2071C5.60536 28.0196 5.5 27.7652 5.5 27.5V13.5C5.5 11.9087 6.13214 10.3826 7.25736 9.25736C8.38258 8.13214 9.9087 7.5 11.5 7.5Z",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 28.5V19C10.5 18.4696 10.7107 17.9609 11.0858 17.5858C11.4609 17.2107 11.9696 17 12.5 17H19.5C20.0304 17 20.5391 17.2107 20.9142 17.5858C21.2893 17.9609 21.5 18.4696 21.5 19V28.5",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5V4.5C12 3.96957 12.2107 3.46086 12.5858 3.08579C12.9609 2.71071 13.4696 2.5 14 2.5H18C18.5304 2.5 19.0391 2.71071 19.4142 3.08579C19.7893 3.46086 20 3.96957 20 4.5V7.5",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.5H18.5",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.5H21.5",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_1093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpackActive);
export default __webpack_public_path__ + "static/media/BackpackActive.508ec85f92e50eb19fca45d8269d766b.svg";
export { ForwardRef as ReactComponent };